import axios from 'axios';

export const exitPreview = (): Promise<void> =>
  axios.get('/api/exit-preview', { params: { redirect: 0 } });
